/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SMSSendRequest } from '../models/SMSSendRequest';
import type { SMSUpdateRequest } from '../models/SMSUpdateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SmsTempService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Send an SMS
     * @returns void
     * @throws ApiError
     */
    public smsSend({
        requestBody,
    }: {
        /**
         * SMS payload
         */
        requestBody: SMSSendRequest,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sms',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Update an SMS
     * @returns void
     * @throws ApiError
     */
    public smsUpdate({
        id,
        requestBody,
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number,
        /**
         * SMS update payload
         */
        requestBody: SMSUpdateRequest,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/sms/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`,
            },
        });
    }

}
